module.exports = "./img/desktop_logo.e3515b4.png";